import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AccountDefinition from './account-definition/account-definition';
import TabPanel, { Item } from "devextreme-react/tab-panel";

const AccountManagement = () => {
    const { t } = useTranslation();
    const params = useParams();

   
    return (
        <TabPanel id="tabs">
            <Item title={t("account_definition")}>
                <AccountDefinition accountId={params.id} ></AccountDefinition>
            </Item>
        </TabPanel>
    )
}
export default AccountManagement